export default "__VITE_ASSET__BD168fZm__"